import { TemplateElement, defineElement, html } from '@webtides/element-js';
import style from './form-submit-element.css';

/**
 * Custom form submit button element.
 *
 * This element defines a submit button with a customizable label
 * and a property to track the submission state.
 *
 * @class FormSubmitElement
 * @property {string} label
 * @property {boolean} isSubmitting
 */
class FormSubmitElement extends TemplateElement {
    /** @type {HTMLFormElement|undefined} - Reference to the parent form element */
    $form;

    properties() {
        return {
            label: '',
            isSubmitting: false,
        };
    }

    connected() {
        this.$form = this.closest('form');
        this.$form?.addEventListener('submit', () => this.isSubmitting = true);
    }

    styles() {
        return [style];
    }

    /**
     * Renders the loading spinner template.
     *
     * @returns {HTMLTemplateElement} The spinner template
     */
    templateSpinner() {
        return html`
            <span class="loading-spinner w-6"></span>
        `;
    }

    /**
     * Renders the button label template.
     *
     * @returns {HTMLTemplateElement} The button label template
     */
    templateButtonLabel() {
        return html`<span>${this.label}</span>`;
    }

    /**
     * Renders the main component template.
     * Shows either the label or spinner based on submission state.
     *
     * @returns {HTMLTemplateElement} The main component template
     */
    template() {
        return html`
            <button class="btn-submit" type="submit" ?disabled="${this.isSubmitting}">
                ${this.isSubmitting ? this.templateSpinner() : this.templateButtonLabel()}
            </button>
        `;
    }
}

defineElement('form-submit-element', FormSubmitElement);
